import { Badge } from "@chakra-ui/react";
import { memo } from "react";
import { MFAttestationStatus } from "state/members/accessReviews";

type StatusDescriptor = {
  label: string;
  bg: string;
  color: string;
  borderColor: string;
};

export const STATUS_DESCRIPTORS: Record<MFAttestationStatus, StatusDescriptor> =
  {
    pending: {
      label: "Awaiting your attestation",
      bg: "warning.50",
      color: "warning.700",
      borderColor: "warning.200",
    },
    attested: {
      label: "Signed",
      bg: "success.50",
      color: "success.700",
      borderColor: "success.200",
    },
    declined: {
      label: "Declined",
      bg: "error.50",
      color: "error.700",
      borderColor: "error.200",
    },
    superseded: {
      label: "Superseded",
      bg: "neutral.100",
      color: "neutral.700",
      borderColor: "neutral.200",
    },
    skipped_no_assignee: {
      label: "Skipped",
      bg: "neutral.100",
      color: "neutral.700",
      borderColor: "neutral.200",
    },
  };

const StatusBadge = memo(({ status }: { status: MFAttestationStatus }) => {
  const desc = STATUS_DESCRIPTORS[status];
  return (
    <Badge
      // Communicate the meaning to screen readers — colour alone shouldn't
      // carry the semantic. role="status" announces non-urgent state changes.
      role="status"
      aria-label={`Status: ${desc.label}`}
      bg={desc.bg}
      color={desc.color}
      border="1px solid"
      borderColor={desc.borderColor}
      fontSize="12px"
      fontWeight="500"
      textTransform="none"
      px="8px"
      py="3px"
      borderRadius="full"
      lineHeight="1.4"
    >
      {desc.label}
    </Badge>
  );
});

StatusBadge.displayName = "StatusBadge";

export default StatusBadge;
